import React from 'react';

import { Row, Col } from 'components/layout';
import Icon from 'components/Icon';

import Feedback from '../Feedback';

import partyPopperImg from '../../assets/images/partyPopper.svg';
import { labelsByVariant } from 'views/Btc/constants';
import theme from 'config/themes';

const CompletedView = ({ variant = '', isStorage }) => {
  const isStorageDoor = isStorage === true;
  const variantKey = variant || '';
  const title = isStorageDoor 
    ? labelsByVariant[variantKey].storageTitle 
    : labelsByVariant[variantKey].completeTitle;
  const message = isStorageDoor 
    ? labelsByVariant[variantKey].storageDescription 
    : labelsByVariant[variantKey].completeDescription;
  const icon = isStorageDoor 
    ? <Icon name="archive" color="#B9C2C9" />
    : (variant === 'v2' ? <Icon name="check-circle" color="#B9C2C9" /> : null);

  return (
    <Row justify="center" align="middle" style={{ height: '100%' }}>
      <Col style={{ textAlign: 'center' }}>
        {variant === 'v2' || isStorageDoor ? null : (
          <Feedback
            title="Congratulations!"
            img={<img src={partyPopperImg} alt="congrats" style={{ height: '8vw' }} />}
            styles={{
              title: { color: theme.primaryColor, fontSize: '6vw', marginBottom: '2vh' }
            }}
          />
        )}
        <Feedback
          title={title}
          message={message}
          img={icon}
        />
      </Col>
    </Row>
  );
};

export default CompletedView;